// 深度复制，解决=带来的引用问题

export function deepCopy(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    let copy = Array.isArray(obj) ? [] : {};

    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = deepCopy(obj[key]);
        }
    }

    return copy;
}

// 时间格式转换
export function formatDate(str,isEndTime) {
    let date = new Date(str);
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let hours = ("0" + date.getHours()).slice(-2);
    let minutes = ("0" + date.getMinutes()).slice(-2);
    let seconds = ("0" + date.getSeconds()).slice(-2);

    return isEndTime ? year + "-" + month + "-" + day + " " + 23 + ":" + 59 + ":" + 59
        : year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
}

